import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AddBtn',
  setup() {
    return {}
  },
})
